export { AuthSEO, default } from './AuthSEO';
